import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=553c37cc&"
import script from "./OrderDetailTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailTable.vue?vue&type=style&index=0&id=553c37cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports